import React from "react";

const IndividualUserForms = () => {
  return <div>IndividualUserForms</div>;
};

export default IndividualUserForms;
